export default __webpack_public_path__ + "static/media/P-037.8184b6b2.png";